import React from 'react';

import VendexElement, {
  VendexButtonMeta,
  VendexCheckboxMeta,
  VendexElementType,
  VendexImageMeta,
  VendexInputMeta,
  VendexMultilineMeta,
  VendexPopItMeta,
  VendexQrMeta,
  VendexRadioMeta,
  VendexTextMeta,
  VendexTimerMeta,
  VendexVideoMeta,
} from '../../models/VendexElement';
import VendexButton from './ViewerElements/VendexButton';
import VendexCheckbox from './ViewerElements/VendexCheckbox';
import VendexImage from './ViewerElements/VendexImage';
import VendexInput from './ViewerElements/VendexInput';
import VendexMultiline from './ViewerElements/VendexMultiline';
import VendexPopIt from './ViewerElements/VendexPopIt';
import VendexQR from './ViewerElements/VendexQr';
import VendexRadio from './ViewerElements/VendexRadio';
import VendexText from './ViewerElements/VendexText';
import VendexTimer from './ViewerElements/VendexTimer';
import VendexVideo from './ViewerElements/VendexVideo';
import VendxLogo from './ViewerElements/VendxLogo';

const Element: React.FC<{ element: VendexElement }> = ({ element }) => {
  switch (element.type) {
    case VendexElementType.IMAGE:
      return <VendexImage id={element.id} data={element.metaData as VendexImageMeta} actions={element.actions} />;
    case VendexElementType.TEXT:
      return <VendexText id={element.id} data={element.metaData as VendexTextMeta} actions={element.actions} />;
    case VendexElementType.TIMER:
      return <VendexTimer id={element.id} data={element.metaData as VendexTimerMeta} actions={element.actions} />;
    case VendexElementType.BUTTON:
      return <VendexButton id={element.id} data={element.metaData as VendexButtonMeta} actions={element.actions} />;
    case VendexElementType.INPUT:
      return <VendexInput id={element.id} data={element.metaData as VendexInputMeta} />;
    case VendexElementType.MULTILINE:
      return <VendexMultiline id={element.id} data={element.metaData as VendexMultilineMeta} />;
    case VendexElementType.VIDEO:
      return <VendexVideo id={element.id} data={element.metaData as VendexVideoMeta} />;
    case VendexElementType.CHECK_BOX:
      return <VendexCheckbox id={element.id} data={element.metaData as VendexCheckboxMeta} />;
    case VendexElementType.RADIO:
      return <VendexRadio id={element.id} data={element.metaData as VendexRadioMeta} />;
    case VendexElementType.POP_IT_GAME:
      return <VendexPopIt id={element.id} data={element.metaData as VendexPopItMeta} />;
    case VendexElementType.QRCODE:
      return <VendexQR id={element.id} data={element.metaData as VendexQrMeta} />;
    default:
      return <VendxLogo />;
  }
};

export default Element;
